<template>
	<div class="full" style="background-color: white;">
		<template v-if="device!=='pc'">
			<template v-if="phonePage=='system'">
				<div class="full flex" style="flex-direction: column;">
					<phone-grid style="flex: 1;" :gridOptions="gridOptions" type="list" :moduleName="moduleName" :loading="loading"
						:ref="moduleName+'_list'" :operateButton="operateButton" :key="gridKey"
						v-if="gridOptions && gridShow" @toolbar-button-click="toolbarButtonClickEvent">
					</phone-grid>
					<slot name='plug'></slot>
				</div>
			</template>
			<template v-else>
				<slot name='phonePage'></slot>
			</template>
		</template>
		<template v-else>
			<div class="module_container full" style="position: relative;">
				<el-container class="full" style="position: relative;">
					<el-header height="45px" class="head" v-if="$slots.mainheader && $slots.mainheader.length!=0">
						<slot name='mainheader'></slot>
					</el-header>
					<el-container class="full" style="position: relative;">
						<el-aside class="aside" :width="asideWidth+'px'" v-if="$slots.aside && $slots.aside.length!=0">
							<slot name='aside'></slot>
						</el-aside>
						<el-main class="main flex">
							<el-container class="full" style="position: relative;">
								<el-header height="auto" class="head" v-if="$slots.header && $slots.header.length!=0">
									<slot name='header'></slot>
								</el-header>
								<el-main class="main flex">
									<div style="position: relative;width: 100%;flex: 1;"
										:style="{height:($slots.footer && $slots.footer.length!=0)?'70%':'100%'}">
										<vxe-grid :id="moduleName+'_list'" v-bind="gridOptions" :loading="loading"
											:key="gridKey" v-if="gridOptions && gridShow" @cell-click="baseCellClick"
											@cell-dblclick="cellDblclick"
											@toolbar-button-click="toolbarButtonClickEvent"
											@menu-click="contextMenuClickEvent" @sort-change="sortChange"
											@edit-closed="editClosed" :ref="moduleName+'_list'">
										</vxe-grid>
									</div>
									<div style="position: relative;width: 100%;height:30%;"
										v-if="$slots.footer && $slots.footer.length!=0">
										<slot name='footer'></slot>
									</div>
								</el-main>
								<!-- 						<el-footer v-if="$slots.footer && $slots.footer.length!=0">
						<slot name='footer'></slot>
					</el-footer> -->
							</el-container>
						</el-main>
					</el-container>
				</el-container>



				<vxe-modal v-model="indexModule.show" width="1200" height="800"
					:title="indexModule.extra.title+'【'+indexModule.extra.notice+'】'" destroy-on-close>
					<template #default>
						<component :is="indexModule.component" :foreingKey="indexModule.foreingKey" />
					</template>
				</vxe-modal>

				<exportTable :ref="exportRef" :forms="forms" :tableColumn="tableColumn" :moduleName="moduleName"
					:windowName="windowName" :beforeexport="beforeexport" :afterexport="afterexport" />
				<importTable :ref="importRef" :componenttype="componenttype" :moduleName="moduleName" />
				
				<sonflow :rows="currentrow" :moduleName="moduleName" ref="sonflow" />
				<slot name='plug'></slot>
			</div>
		</template>
		<formwindow :formConfig="formModule" v-if="formwindowShow" @reloadList="customreload" @back="formBack" />
		<template>
			<component :key="Math.random()" :is="formModule.component" :name="formModule.name" :id="formModule.id"
				:controlltype="formModule.controlltype" :extra="formModule.extra" :foreingKey="formModule.foreingKey"
				:windowType="formModule.windowType" @back="formBack" :windowName="formModule.windowName"
				:isflow="formModule.isflow" :flowprogressid="formModule.flowprogressid" :flowid="formModule.flowid"
				@activeEdit="activeEdit" @show="formshow" />
		</template>
	</div>

</template>
<style scoped>
	.module_container {
		box-sizing: border-box;
		padding-bottom: 10px;
	}

	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}

	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}

	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;

	}

	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;
	}
</style>

<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import exportTable from '@_system/components/export/index.vue'
	import importTable from '@_system/components/import/index.vue'
	import sonflow from '@_system/components/sonflow/index.vue'
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	//import exportMixins from '@_system/components/base/mixins/list/export.js'
	//import importMixins from '@_system/components/base/mixins/list/import.js'
	export default {
		mixins: [listMixins],
		props: {
			foreingKey: {
				type: Object,
				default: () => {
					return {}
				}
			},
			extra: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				mode: 'list',
				phonePage: 'system',
				device: window.systemMethods.device(),
				asideWidth: 250,
				statisticslist: null,
				statisticsfield: null,
				sourcestatisticsdata: {},
				ids: [],
				componenttype: window.config.app,
				loading: false,
				formenabled: true,
				sourcedata:null,
				autoLoad: true,
				currentrow: null,
				moduleName: '',
				windowName: '',
				windowType: 'modal',
				toolbarButtonList: this.$store.state.system.toolbarButtonList,
				operateButtonList: this.$store.state.system.operateButtonList,
				// exportIds: [],
				gridShow: true,
				tools: [],
				toolbarButton: [],
				operateButton: null,
				toolbarButtonConfig: [],
				operateButtonConfig: [],
				operateInrowButton: [],
				defaultFormValue:[],
				// defaultFormValue:[{
				// 	field:"brand",
				// 	default:[8006]
				// }],
				columns: [],
				sonlistfield:[],
				formsConfig:null,
				indexModule: {
					component: '',
					show: false,
					foreingKey: {},
					extra: {},
				},
				formModule: {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					foreingKey: {},
					extra: {},
					windowName: '',
					windowType: 'modal',
					isflow: 0,
					flowprogressid: 0,
					flowid: 0,

				},
				gridKey: Math.random(),
				gridOptions: null,
				editShow: false,
				formwindowShow: false,
				tableColumn: [],
				forms: [],
				importRef: Math.random(),
				exportRef: Math.random(),
				menuConfig: null,
				pagerConfig: {
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 200, 500],
				},
				// exportConfig: [],


				// exportinit: false,
				// exportSystemColumn: {
				// 	title: '全部',
				// 	label: 'total',
				// 	field: []
				// },
				// exportFieldType: 'total',
				// exportCustomColumn: [],
				// exportNoticeShow: false,
				// exportParam: [],

			}
		},
		created() {
			this.toolbarButtonList = this.toolbarButtonList.concat(this.$store.state.toolbarButtons)
			this.operateButtonList = this.operateButtonList.concat(this.$store.state.operateButtons)
			this.initList()
		},
		computed: {
			// proxyInfo(){
			// 	this.$nextTick(() => {
			// 		if (this.$refs[this.moduleName + '_list']) {
			// 			this.$refs[this.moduleName + '_list'].commitProxy('query')
			// 		}
			// 	})

			// }
		},
		methods: {
			add() {
				this.addformShow()
			},
			addformShow(extra = {}) {
				if (this.windowType == 'window') {
					let res = this.$router.resolve({
						name: 'add',
						query: {
							name: this.moduleName,
							id: 0,
							controlltype: 1,
							windowName: '新建' + this.windowName,
							foreingKey: JSON.stringify({}),
							extra: JSON.stringify(extra)
						}
					})
					let win = window.open(res.href, this.moduleName + 'add',
						this.$store.state.system.windowConfig)
					win.onload = () => {

					}
				} else {
					this.formModule = {
						name: this.moduleName,
						id: 0,
						controlltype: 1,
						windowName: '新建' + this.windowName,
						foreingKey: {},
						extra: extra
					}
					this.formwindowShow = true
				}
			},
			edit(row) {
				this.editformShow(row)
			},
			editformShow(row, extra = {}) {
				if (this.windowType == 'window') {
					let res = this.$router.resolve({
						name: 'update',
						query: {
							name: this.moduleName,
							id: row.id,
							controlltype: 2,
							windowName: '编辑' + this.windowName,
						}
					})
					let win = window.open(res.href, this.moduleName + 'edit',
						this.$store.state.system.windowConfig)
					win.onload = () => {

					}
				} else {
					this.formModule = {
						name: this.moduleName,
						id: row.id,
						controlltype: 2,
						windowName: '编辑' + this.windowName,
						foreingKey: {},
						extra: extra
					}
					this.formwindowShow = true
				}
			},
			activeEdit() {

			},
			formshow() {

			},
			reaudit(row) {
				this.loading = true
				this.$api.module.reaudit(window.config.app, this.moduleName, {
					id: row.id,
					type: 'reaudit'
				}).then(() => {
					this.loading = false
					this.$message.success('操作成功')
					this.customreload()
				}, () => {
					this.loading = false
				})

			},
			batchreaudit(){
				let data =  this.$refs[this.moduleName + '_list'].getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				this.batchreauditVerify(data).then(()=>{
					let promisearr = []
					data.forEach((item)=>{
						promisearr.push(
							new Promise((reslove)=>{
								this.$api.module.reaudit(window.config.app, this.moduleName, {
									id: item.id,
									type: 'reaudit'
								}).then(() => {
									reslove()
								},()=>{
									reslove()
								})
							})					
						)})
					this.loading = true
					Promise.all(promisearr).then(()=>{
						this.loading = false
						this.$message.success('操作成功')
						this.customreload()
					},()=>{
						this.loading = false
						this.customreload()
					})
				},(e)=>{
					this.$message.error(e)
				})
			},
			batchreauditVerify(){
				return new Promise((reslove)=>{
					reslove()
				})
			},
			unaudit(row) {
				this.loading = true
				this.$api.module.reaudit(window.config.app, this.moduleName, {
					id: row.id,
					type: 'unaudit'
				}).then(() => {
					this.loading = false
					this.$message.success('操作成功')
					this.customreload()
				}, () => {
					this.loading = false
				})
			
			},
			preview(row) {
				this.previewformShow(row)
			},
			previewformShow(row) {
				if (this.windowType == 'window') {
					let res = this.$router.resolve({
						name: 'add',
						query: {
							name: this.moduleName,
							id: row.id,
							controlltype: 3,
							windowName: '编辑' + this.windowName,
						}
					})
					let win = window.open(res.href, this.moduleName + 'edit',
						this.$store.state.system.windowConfig)
					win.onload = () => {

					}
				} else {
					this.formModule = {
						name: this.moduleName,
						id: row.id,
						controlltype: 3,
						windowName: '编辑' + this.windowName,
						foreingKey: {},
						extra: {}
					}
					this.formwindowShow = true
				}
			},
			initToolbarButton() {
				let buttons = []
				let groups = []
				let tools = []
				//let dropdowns = []
				if (this.toolbarButtonConfig) {
					// if (this.toolbarButtonConfig.includes('exportall') || this.toolbarButtonConfig.includes('exportcurrent')) {
					// 	this.toolbarButtonConfig.push('exportpanel')
					// }
					// console.log(this.toolbarButtonConfig,this.toolbarButtonList)
					this.toolbarButtonConfig.forEach((item) => {
						this.toolbarButtonList.forEach((button) => {
							if (button.code == item && !button.custom) {
								if (button.tools) {
									let tbutton = JSON.parse(JSON.stringify(button))
									tbutton.name = ''
									tools.push(tbutton)
								} else {
									if (item != 'exportcurrent' && item != 'exportall') {
										if (!button.group) {
											buttons.push(button)
										} else {
											if (!groups[button.group.name]) {
												groups[button.group.name] = {
													groupconfig: button.group,
													buttons: [],
												}
											}
											button.type = 'text'
											button.status = ''
											groups[button.group.name].buttons.push(button)
										}
									}
								}
							}
						})
					})
					for (let i in groups) {
						buttons.push({
							name: i,
							status: groups[i].groupconfig.status,
							dropdowns: groups[i].buttons
						})
					}
				}
				this.toolbarButton = buttons
				this.tools = tools
			},
			initOperateButton() {
				let buttons = []
				if (this.operateButtonConfig) {
					this.operateButtonConfig.forEach((item) => {
						this.operateButtonList.forEach((button) => {
							if (button.code == item) {
								buttons.push(button)
							}
						})
					})
				}
				buttons.forEach((item) => {
					let buff = !!item.inrow
					if (buff) {
						this.operateInrowButton.push(item)
					}
				})

				this.operateButton = {
					bind: this,
					name: '$operateButton',
					buttons: buttons
				}
			},
			initList() {
				//console.log(this.moduleName)
				this.$api[this.moduleName].init({
					mode: this.mode
				}).then((res) => {
					this.sonlistfield = res.sonlistfield
					this.formsConfig = res.formsConfig
					this.toolbarButtonConfig = res.toolbarButtonConfig
					this.operateButtonConfig = res.operateButtonConfig
					this.forms = res.forms
					this.columns = res.columns
					if(this.alterInitList){
						this.alterInitList(res)
					}
					this.initToolbarButton()
					this.initOperateButton()
					this.initOption()

				})
			},
			sortChange() {

			},
			initOption() {
				let gridOptions = this.getOption()
				gridOptions.id = this.moduleName + '_listmodule',
				gridOptions.proxyConfig.autoLoad = this.autoLoad
				gridOptions.cellStyle = this.cellStyle
				gridOptions.menuConfig = this.menuConfig	
				gridOptions.pagerConfig = this.pagerConfig		
				gridOptions.toolbarConfig =  {
					size: 'mini',
					perfect: false,
					buttons: this.toolbarButton,
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: this.tools
				}
				gridOptions.tooltipConfig = {
					showAll: true,
					enterable: true,
					contentMethod: this.tipcontentMethod
				},
				gridOptions.treeConfig = {
					lazy: true,
					transform: true,
					rowField: 'id',
					parentField: 'parentid',
					line: false,
					expandAll: false,
					loadMethod: this.loadMethod
				}
				gridOptions.editConfig = {
					trigger:'click',
					mode:'cell'
				}
				gridOptions.importConfig = {
					types: ['xls', 'xlsx'],
					remote: true,
					importMethod: this.importMethod ? this.importMethod : this.import
				}
				gridOptions.exportConfig = {
					type: 'xlsx',
					types: ['xlsx', 'csv', 'html', 'xml', 'txt'],
					remote: true,
					exportMethod: this.exportMethod ? this.exportMethod : this.export
				}
				gridOptions.columns = this.getColumns(this.columns)
				gridOptions.formConfig = this.getForm(this.columns)
				gridOptions.checkboxConfig = {
					//labelField: gridOptions.columns[0] ? gridOptions.columns[0].field : '',
				}
				gridOptions.radioConfig = {
					//labelField: gridOptions.columns[0] ? gridOptions.columns[0].field : '',
				}
				if (this.beforeCreateGrid) {
					this.beforeCreateGrid(gridOptions.formConfig, gridOptions.columns, gridOptions)
				}
				this.gridOptions = gridOptions
			},
			getOption() {
				let list_getOption = this.list_getOption()
				this.list_gridOptions = list_getOption
				return list_getOption
			},
			list(page,updateForm,other) {
				let sonlistfield = this.sonlistfield.filter((item)=>{
					return item.value
				})
				if(sonlistfield.length){
					sonlistfield = this.$Lodash.groupBy(sonlistfield, 'group')
					for(let i in sonlistfield){
						sonlistfield[i] = this.$Lodash.groupBy(sonlistfield[i], 'field')
					}
				}else{
					sonlistfield = null
				}
				this.sourcestatisticsdata = {}
				if(this.$refs[this.moduleName+'_list'].updateFooter){
					this.$refs[this.moduleName+'_list'].updateFooter()
				}
				
				
				return new Promise((resolve,reject) => {
		
					this.$api[this.moduleName].list({
						...page,
						...updateForm,
						...other,
						...this.foreingKey,
						...{sonlistfield:sonlistfield}
					}).then((res) => {
						if(this.statisticsfield){
							this.$api[this.moduleName].list({
								...page,
								...updateForm,
								...other,
								...this.foreingKey,
								...{sonlistfield:sonlistfield},
								...{statisticsfield:this.statisticsfield}
							}).then((res)=>{
								this.sourcestatisticsdata = res.list[0]
								if(this.$refs[this.moduleName+'_list'].updateFooter){
									this.$refs[this.moduleName+'_list'].updateFooter()
								}
							})
						}
						this.currentrow = null
						if (this.afterGet) {
							this.afterGet(res,updateForm)
						}
						//console.log(res)
						this.sourcedata = res
						resolve(res)
					}, () => {
						reject()
					})
				})
			},
			
			getForm(data) {
				let items = []
				data.forEach((item) => {
					if (item.render) {
						let hasDefault = this.defaultFormValue.find((defaultitem)=>{
							return defaultitem.field == item.field
						})
						let formitem = JSON.parse(JSON.stringify(item))		
										//console.log(item.props)
						let obj = {
							field: formitem.field,
							title: formitem.title,
							resetValue:hasDefault?hasDefault.default:null,
							// folding: items.length >= 3,
							// span: item.field.match(/.*time$/g) ? 8 : 4,
							span: 4,
							itemRender: {
								defaultValue:hasDefault?hasDefault.default:null,
								name: formitem.render,
								options: [],
								optionProps: {

								},
								props: {
									islist: true,
									listforeingKey:this.foreingKey,
									name: formitem.name,
									size: 'mini',
									placeholder: '',
									...formitem.props,
								},
							},
						}
						//console.log(formitem.props,obj.title)
						items.push(obj)
					}
				})
	
				if (items.length != 0) {
					items.push({
						align: 'left',
						span: 24,
						itemRender: {
							name: '$tableformbutton',
							props:{
								table:this
							}
						}
					})
				}
				return {
					titleOverflow:true,
					titleWidth: '80',
					titleAlign: 'center',
					items: items,
					enabled: this.formenabled,
					span: 6
				}
			},
			getColumns(data) {
				let selecttype = null
				let columns = []
				data.forEach((item) => {
					if (item.visible !== false) {
						this.tableColumn.push({
							field: item.field,
							title: item.title
						})
					}
					let slots = {}
					if(item.type == 'expand'){
						slots.content = ({row})=>{
							let str = []
							row[item.field].forEach((_item) => {
								str.push( <div style = "margin:20px" > {_item.name + '（' + _item.code + '）'} </div>)
							})
							return str
						}
					}
					if(item.formatter == 'file'){
						slots.default = ({row})=>{
							return <upload value={(row[item.field] && row[item.field]!="null") ?row[item.field]:[]} readonly />
						}
					}
					if(!selecttype){
						selecttype = item.type
					}
					
					let obj = {
						field: item.field,
						title: item.title,
						showHeaderOverflow: 'tooltip',
						sortable: item.sortable,
						fixed: item.fixed ? item.fixed : null,
						minWidth: item.width ? item.width : 'auto',
						// type: item.type ? item.type : null,
						slots:slots,
						// slots: item.type == 'expand' ? {
						// 	content: ({
						// 		row
						// 	}) => {
						// 		let str = []
						// 		row[item.field].forEach((_item) => {
						// 			str.push( <div style = "margin:20px" > {_item.name + '（' + _item.code + '）'} </div>)
						// 		})
						// 		return str
						// 	}
						// } : null,
						formatter: (item.formatter && item.formatter!='file') ? ({
							row
						}) => {
							return window.systemMethods.formatter(row, item)
						} : null,
						visible: item.visible,
						// treeNode: item.treeNode,
						treeNode: item.type == 'treeNode',
					}
					if (item.props && item.props.selectoptions && item.props.selectoptions.length != 0) {
						obj.formatter = ({
							row
						}) => {
							let options = item.props.selectoptions.find((opv) => {
								return opv.value == row[item.field]
							})

							return options ? options.label : null
						}
					}
					if (item.props) {
						if (item.props.penetrate) {
							obj.editRender = {
								name: '$quote',
								props: item.props
							}
						}
						if (item.props.flowstatus) {
							obj.editRender = {
								name: '$flowstatus',
								props: item.props,
								events: {}
							}
						}
						if (item.props.auditorstaffid) {
							obj.editRender = {
								name: '$auditorstaffid',
								props: item.props,
								events: {}
							}
						}
						
						if (item.props.copycontent && !obj.editRender && !obj.slots) {
							obj.slots = {
								default: ({
									row,
									column
								}) => {
									return <div>
										<i style ="margin-right:6px;cursor: pointer;font-size:14px;color:#409EFF" onClick = {() => {this.copycontent(column, row)}} class="el-icon-document-copy"></i> 
										<span> {row[column.field]} </span> 
									</div>
								},
								header: ({
									column
								}) => {
									return <div>
										<i style ="margin-right:6px;cursor: pointer;font-size:14px;color:#409EFF" onClick = {()=>{this.copycontent(column, null)}} class="el-icon-document-copy"></i> 
										<span>{column.title}</span> 
									</div>
								}
							}
						}
					}
					columns.push(obj)

				})
				
				if(selecttype){
					columns.unshift({
						fixed:'left',
						width:50,
						type:selecttype,
						title:''
					})
				}
				
				if (data.length != 0 && this.operateButtonConfig.length != 0) {
					let cellwidth = (this.operateInrowButton.length == this.operateButtonConfig.length ? this
							.operateInrowButton.length : this.operateInrowButton.length + 1) * 50
					//console.log(this.operateInrowButton , this.operateButtonConfig)
					columns.push({
						field: '',
						title: '操作',
						width: Math.max(cellwidth,120),
						fixed: "right",
						align: 'center',
						visible: Boolean(this.operateButtonConfig.length),
						cellRender: this.operateButton
					})
				}
				
				//console.log(this.operateButton)
				return columns
			},
			baseCellClick(e) {
				if (e.column.field) {
					this.cellClick(e)
				}
			},
			cellClick() {

			},
			cellDblclick() {

			},
			tipcontentMethod({row,column}) {
				if(row && row.extend_tag){
					let hastag = row.extend_tag.find((item)=>{
						return item.field == column.field
					})
					if(hastag){
						return ''
					}
				}
				if(column.editRender && column.editRender.props.penetrate){
					return ''
				}
				
	
				if(row && column.field){
					return row[column.field]
				}else{
					return ''
				}
			},
			getGrid() {
				return this.$refs[this.moduleName + '_list']
			},
			toolbarButtonClickEvent(e, execute = true) {
				return new Promise((resolve, reject) => {
					this.$api.module.moduleConfig(this.componenttype, this.moduleName).then((res) => {
						let toolbarButtonConfig = res.toolbarButtonConfig
						let index = toolbarButtonConfig.findIndex((item) => {
							return item == e.code
						})
						if (index !== -1) {
							if (execute) {
								this[e.code]()
							}
							resolve()
						} else {
							this.$message.error('暂无操作权限')
							reject()
						}
					})
				})
			},
			operateButtonClickEvent(e) {
				this.$api.module.moduleConfig(this.componenttype, this.moduleName).then((res) => {
					let operateButtonConfig = res.operateButtonConfig
					let index = operateButtonConfig.findIndex((item) => {
						return item == e.code
					})
					if (index !== -1) {
						this[e.code](e.data)
					} else {
						this.$message.error('暂无操作权限')
					}
				})
			},
			formBack(e) {
				this.formwindowShow = false
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				}
				if (this.device != 'pc') {
					this.$refs[this.moduleName + '_list'].actionHide()
				}

				if (e.type != 'cancle') {
					this.customreload()
				}
			},
			reload() {

			},
			customreload() {
				this.$nextTick(() => {
					if (this.$refs[this.moduleName + '_list']) {
						this.$refs[this.moduleName + '_list'].commitProxy('query')
					}
				})
			},
			del(row) {
				this.$confirm('是否确认删除 ' + (row.code ? row.code : ''), '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api[this.moduleName].delete(row.id).then(() => {
						this.loading = false
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.customreload()
					},()=>{
						this.loading = false
					})
				}).catch(() => {
					this.loading = false
				})
			},
			batchdelete(){
				let data =  this.$refs[this.moduleName + '_list'].getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				this.batchdeleteVerify(data).then(()=>{
					this.$confirm('是否确认批量删除', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						let promisearr = []
						data.forEach((item)=>{
							promisearr.push(
								new Promise((reslove)=>{
									this.$api[this.moduleName].delete(item.id).then(() => {
										reslove()
									},()=>{
										reslove()
									})
								})					
							)})
						this.loading = true
						Promise.all(promisearr).then(()=>{
							this.loading = false
							this.$message.success('操作成功')
							this.customreload()
						},()=>{
							this.loading = false
							this.customreload()
						})
					
					}).catch(() => {
					
					})
				},(e)=>{
					this.$message.error(e)
				})
			},
			batchdeleteVerify(){
				return new Promise((reslove)=>{
					reslove()
				})
			},
			sonflow(row) {
				this.currentrow = [row]
				this.$refs.sonflow.modal_show()
			},
			batchsonflow() {
				let rows = this.$refs[this.moduleName+'_list'].getCheckboxRecords()
				if(!rows.length){
					this.$message.error('请选择数据')
					return
				}
				this.currentrow = rows
				this.$refs.sonflow.modal_show()
			},
			copycontent(column, row) {
				if (row) {
					if(row[column.field]){
						this.$copyText(row[column.field]).then(() => {
							this.$message.success('复制成功')
						}, () => {
							this.$message.success('复制失败')
						})
					}else{
						this.$message.error('无可复制内容')
					}

				} else {
					let fullData = this.getGrid().getTableData().fullData
					let content = []
					fullData.forEach((item) => {
						if(item[column.field]){
							content.push(item[column.field])
						}
						
					})
					this.$copyText(content.join('\n')).then(() => {
						this.$message.success('复制成功')
					}, () => {
						this.$message.success('复制失败')
					})

				}
			},
			cellStyle() {

			},
			editClosed() {

			},
			beforeexport() {
				return new Promise((resolve) => {
					resolve()
				})
			},
			afterexport() {

			},
			exportpanel() {
				this.$refs[this.exportRef].exportNoticeShow = true
			},
			loadMethod() {

			},
			importpanel() {
				this.$refs[this.importRef].importpanel()
			},
			contextMenuClickEvent() {

			},
			// exportcurrent(){
			// 	this.$refs[this.moduleName + '_list'].exportData({
			// 		filename: this.moduleName,
			// 		type: 'xlsx',
			// 		remote: false,
			// 	})	
			// },
			timestampToTime(timestamp) {
				let date = new Date(timestamp * 1000)
				let Y = date.getFullYear() + "-"
				let M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-"
				let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " "
				let h = date.getHours() + ":"
				let m = date.getMinutes() + ":"
				let s = date.getSeconds()
				return Y + M + D + h + m + s
			}
		},
		components: {
			exportTable,
			importTable,
			sonflow,
			upload
		}
	}
</script>